import businessClient from 'src/services/clients/business'
import { IMeta, ICustomerGroup } from 'src/common/interfaces/index.js'

const ISettingsCustomerGroupsListResponse = { meta: IMeta, data: { list: [ICustomerGroup] } }
const ISettingsCustomerGroupUpsertArgs = { name: 'VIP 0' }

export const settingsCustomerGroups = {
  /**
   * @param {{id: number, name: string}} filter
   * @return {ISettingsCustomerGroupsListResponse}
   */
  list(filter, signal) {
    return businessClient().post('settings/customer_group/portal/list', { filter }, { signal })
  },

  /**
   * @param {ISettingsCustomerGroupUpsertArgs} data
   * @return {upsert: [ICustomerGroup]}
   */
  upsert(data, signal) {
    return businessClient().post('settings/customer_group/upsert', { data }, { signal })
  },

  /**
   * @param {id: number} filter
   * @return {archive: [ICustomerGroup]}
   */
  archive(filter, signal) {
    return businessClient().post('settings/customer_group/archive', { filter }, { signal })
  },
}
